import { ww, q } from 'bobjoll/ts/library/dom';
import { Editor } from 'Pods/editor/editor';
import { scale as iconScale } from 'Pods/editor/transformation';
import { Shape as ShapeClass } from '@svgdotjs/svg.js';

const maxSize = 100;
const ratioImageScale = 70;
let shape: ShapeClass;
let type: shapeType;
let size = maxSize;
let fillColor = '#BAC8D3';
let colorPicker: any;
let reScaled = false;

const handleEventShapes = () => {
    let buttonsShapeElements = document.querySelectorAll('.detail__editor__forms .shape-type button');
    buttonsShapeElements.forEach(element => {
        element?.removeEventListener('click', addShape);
        element?.addEventListener('click', addShape);
    });
    if (!colorPicker) {
        colorPicker = ww.Pickr.create({
            el: '.shape-color-picker-wrapper',
            showAlways: true,
            inline: true,
            comparison: false,
            useAsButton: false,
            defaultRepresentation: 'HEX',
            default: 'BAC8D3',
            components: {
                preview: false,
                opacity: false,
                hue: true,
                interaction: {
                    hex: false,
                    rgba: false,
                    hsla: false,
                    hsva: false,
                    cmyk: false,
                    input: true,
                    clear: false,
                    save: false,
                },
            },
        });

        colorPicker.on('change', (color: any) => {
            fillShape(
                color
                    .toHEXA()
                    .toString()
                    .toLowerCase(),
            );
        });
        colorPicker.on('changestop', (_source: string, instance: any) => {
            let color = instance
                .getColor()
                .toHEXA()
                .toString()
                .toLowerCase();
            fillShape(color);
        });

        q('.pcr-result')?.setAttribute('maxlength', '7');
    }

    let rangeShapeElement = document.querySelector('.detail__editor__forms input[type="range"]') as HTMLInputElement;
    rangeShapeElement?.removeEventListener('input', changeSizeValue);
    rangeShapeElement?.addEventListener('input', changeSizeValue);

    let inputSizeElement = document.querySelector('.detail__editor__forms input[type="number"]') as HTMLInputElement;
    inputSizeElement?.removeEventListener('change', changeSizeValue);
    inputSizeElement?.addEventListener('change', changeSizeValue);
};

const addShape = (e: Event) => {
    let buttonsShapeElement = e.currentTarget as HTMLElement;
    let action = buttonsShapeElement.dataset.action;
    let value = buttonsShapeElement.dataset.values;
    if (action == 'shape') {
        switch (value) {
            case 'circle':
                circle();
                break;
            case 'square':
                square();
                break;
            case 'rounded':
                rounded();
                break;
            case 'none':
                reset();
                type = undefined;
                break;
        }
    }
    const currentBtn = document.querySelector('.detail__editor__forms .shape-type button.active');
    currentBtn?.classList.remove('active');
    buttonsShapeElement.classList.add('active');
};

const changeSizeValue = (e: Event) => {
    e.stopPropagation();
    let element = e.currentTarget as HTMLInputElement;
    if (element.type == 'range') {
        let inputSizeElement = document.querySelector(
            '.detail__editor__forms input[type="number"]',
        ) as HTMLInputElement;
        inputSizeElement.value = element.value;
    } else {
        let rangeSizeElement = document.querySelector('.detail__editor__forms input[type="range"]') as HTMLInputElement;
        rangeSizeElement.value = element.value;
    }

    size = parseFloat(element.value);
    // @ts-ignore
    shape?.transform({ scale: size / 100, origin: 'center' });
};

const circle = () => {
    if (!type || type != 'circle') {
        reset();
        showTools();
        reScale();
        shape = Editor.draw
            .circle(Editor.draw.width())
            .radius(Editor.draw.viewbox().width / 2)
            .cx(Editor.draw.viewbox().width / 2)
            .cy(Editor.draw.viewbox().height / 2)
            .back()
            .fill(fillColor)
            .attr({
                shape: 'circle',
            });
        type = 'circle';
        let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
        saveIntoButtonElement.disabled = false;
        Editor.setAlertAndDownloadButton(false);
    }
};

const rounded = () => {
    if (!type || type != 'rounded') {
        reset();
        showTools();
        reScale();
        shape = Editor.draw
            .rect(Editor.draw.viewbox().width, Editor.draw.viewbox().height)
            .radius(Editor.draw.viewbox().width / 5)
            .back()
            .fill(fillColor)
            .attr({
                shape: 'rounded',
            });
        type = 'rounded';
        let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
        saveIntoButtonElement.disabled = false;
        Editor.setAlertAndDownloadButton(false);
    }
};

const square = function() {
    if (!type || type != 'square') {
        reset();
        showTools();
        reScale();
        shape = Editor.draw
            .rect(Editor.draw.viewbox().width, Editor.draw.viewbox().height)
            .back()
            .fill(fillColor)
            .attr({
                shape: 'square',
            });
        type = 'square';
        let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
        saveIntoButtonElement.disabled = false;
        Editor.setAlertAndDownloadButton(false);
    }
};

const fillShape = (color: string) => {
    fillColor = color;
    shape?.fill(color);
};

const reScale = () => {
    if (Editor.draw.find('g')[0].transform().scaleX == 1) {
        iconScale(ratioImageScale, true, true);
        reScaled = true;
    }
};

const showTools = () => document.getElementById('editor__forms__options')?.classList.remove('hide');

const reset = () => {
    Editor.history?.checkButtonStatus();
    document.getElementById('editor__forms__options')?.classList.add('hide');
    shape?.remove();
    type = undefined;
    let inputSizeElement = document.querySelector('.detail__editor__forms input[type="number"]') as HTMLInputElement;
    inputSizeElement.value = maxSize.toString();
    let rangeSizeElement = document.querySelector('.detail__editor__forms input[type="range"]') as HTMLInputElement;
    rangeSizeElement.value = maxSize.toString();
    size = maxSize;
    colorPicker?.setColor(fillColor);

    if (reScaled) {
        iconScale(100, true, true);
    }

    document.querySelectorAll('.detail__editor__forms .shape-type button').forEach(element => {
        element.classList.remove('active');
    });
};

export const Shape = {
    handleEventShapes,
    reset,
};

type shapeType = 'circle' | 'rounded' | 'square' | undefined;
